import moment from 'moment/moment'
import React from 'react'
import {ModeleClientDemandeEtape} from './Models'
import IconMail from './icon/IconMail'
import IconPhone from './icon/IconPhone'
import IconComptoir from './icon/IconComptoir'
import IconFrpa from './icon/IconFrpa'
import IconTelevente from './icon/IconTelevente'
import IconInternet from './icon/IconInternet'
import {toast} from 'react-toastify'
import {Tooltip} from 'react-tooltip'

export const renderNiveauDelai = (fromDate) => {
  const currentDate = moment()
  const dateDemande = moment(fromDate)

  var duration = moment.duration(currentDate.diff(dateDemande))
  var hours = duration.asHours()

  if (hours < 6) {
    return <i className='bi bi-hourglass-top fs-5 text-success'></i>
  } else if (hours < 12) {
    return <i className='bi bi-hourglass-split fs-5 text-warning'></i>
  } else {
    return <i className='bi bi-hourglass-bottom fs-5 text-danger'></i>
  }
}

export const renderStatut = (
  etape: ModeleClientDemandeEtape | undefined,
  intervention?: boolean | undefined,
  displayBlock?: boolean | undefined
) => {
  if (intervention) return <span className={`badge badge-warning ${displayBlock ? 'd-block text-center' : ''}`}>Intervention</span>

  let textClass = ''
  if (etape?.code) {
    if (['NOUVE'].includes(etape?.code)) {
      textClass = 'light'
    } else if (['ASSIG'].includes(etape?.code)) {
      textClass = 'light-warning'
    } else if (['PROPO'].includes(etape?.code)) {
      textClass = 'info'
    } else if (['REFUS'].includes(etape?.code)) {
      textClass = 'light-danger'
    } else if (['CLOTN'].includes(etape?.code)) {
      textClass = 'danger'
    } else if (['ACCEP'].includes(etape?.code)) {
      textClass = 'light-success'
    } else if (['CLOTP'].includes(etape?.code)) {
      textClass = 'success'
    } else if (['BLOQU'].includes(etape?.code)) {
      textClass = 'danger'
    } else if (['MODIF'].includes(etape?.code)) {
      textClass = 'warning'
    } else if (['ECHEC'].includes(etape?.code)) {
      textClass = 'light-warning-echec'
    } else if (['INDIS'].includes(etape?.code)) {
      textClass = 'warning'
    }
  }

  return <span className={`badge badge-${textClass} ${displayBlock ? 'd-block text-center' : ''}`}>{etape?.libelle}</span>
}

export const renderDemontageStatut = (statutlibelle) => {
  let texteClass = ''

  switch (statutlibelle) {
    case 'Nouvelle':
      texteClass = 'light text-gray-600'
      break
    case 'Validée':
      texteClass = 'primary'
      break
    case 'Refusée':
      texteClass = 'danger'
      break
    case 'Annulée':
      texteClass = 'warning'
      break
    case 'En cours de démontage':
      texteClass = 'secondary text-gray-600'
      break
    case 'Démontée':
      texteClass = 'info'
      break
    case 'Demande de transfert':
      texteClass = 'success'
      break
    default:
      texteClass = 'info'
  }

  return <span className={`badge badge-light-${texteClass}`}>{statutlibelle}</span>
}

export const renderIconSource = (demandeSourceId: any, iconOnly: boolean, active: boolean, withTooltip: boolean) => {
  let iconSource
  let iconLabel

  switch (demandeSourceId) {
    case 1:
      iconSource = <IconMail active={active} />
      iconLabel = 'Mail'
      break
    case 2:
      iconSource = <IconPhone active={active} />
      iconLabel = 'Téléphone'
      break
    case 3:
      iconSource = <IconComptoir active={active} />
      iconLabel = 'Comptoir'
      break
    case 4:
      iconSource = <IconFrpa active={active} />
      iconLabel = 'FRPA'
      break
    case 5:
      iconSource = <IconTelevente active={active} />
      iconLabel = 'Direct télévente'
      break
    case 6:
      iconSource = <IconInternet active={active} />
      iconLabel = 'Site internet'
      break
  }

  return (
    <div
      className={`${iconOnly ? '' : 'd-flex gap-2'}`}
      data-tooltip-id='icon-tooltip'
      data-tooltip-content={`${iconLabel}`}
      data-tooltip-place='right'
    >
      <i>{iconSource}</i>
      {!iconOnly && <label>{iconLabel}</label>}
      { withTooltip && <Tooltip id='icon-tooltip' />}
    </div>
  )
}
export const copyText = (
  text: string,
  callback?: (copiedText: string | null) => void,
  delay: number = 500
) => {
  if (!text) return

  navigator.clipboard
    .writeText(text)
    .then(() => {
      // Appeler le callback si fourni (ex: pour mettre à jour l'état)
      if (callback) {
        callback(text)
        setTimeout(() => {
          callback(null)
        }, delay)
      }
      toast.info(`${text} copié`)
    })
    .catch((err) => {
      console.error('Erreur de copie :', err)
    })
}

export const renderPieceStatus = (etat) => {
  const capitalizaFirstletter = (str: string = '') => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }
  let textClass = ''
  if (etat) {
    if (['NC'].includes(etat)) {
      textClass = 'orange'
    } else if (['TRèS BIEN'].includes(etat)) {
      textClass = 'primary'
    } else if (['BIEN'].includes(etat)) {
      textClass = 'success'
    } else if (['MOYEN'].includes(etat)) {
      textClass = 'yellow'
    } else {
      textClass = 'grey'
    }
  }

  return (
    <span
      className={`badge badge-light-${textClass} border border-light-${textClass} w-100 justify-content-center`}
    >
      {capitalizaFirstletter(etat)}
    </span>
  )
}

export const getCurrentHour = () => {
  const now = new Date()
  const heures = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  return `${heures}:${minutes}`
}

export const extractedHour = (dateISO: string): string => {
  if (!dateISO) return ''
  return dateISO.split('T')[1]?.slice(0, 5) || ''
}

export const dayOrder = ['LUN', 'MAR', 'MER', 'JEU', 'VEN']

export const getDayLabel = (day: string) => {
  const dayLabels: Record<string, string> = {
    LUN: 'Lundi',
    MAR: 'Mardi',
    MER: 'Mercredi',
    JEU: 'Jeudi',
    VEN: 'Vendredi',
  }

  return dayLabels[day]
}